import React from "react";
import { QueryClient, QueryClientProvider } from "react-query";

const withQueryClient =
  (Component: React.ComponentType) =>
  ({ ...props }) => {
    const queryClient = new QueryClient({
      defaultOptions: {
        queries: {
          refetchOnMount: false,
          refetchOnReconnect: false,
          refetchOnWindowFocus: false,
          retry: false,
          suspense: false,
        },
      },
    });

    return (
      <QueryClientProvider client={queryClient}>
        <Component {...props} />
      </QueryClientProvider>
    );
  };

export default withQueryClient;
